<template>
    <div>
        <TitleBar>
            <template v-slot:title>
                <translate>Documents</translate>
            </template>
            <template v-slot:buttons>
                <GekkoButton 
                    @click="upload()" 
                    :text="$gettext('Upload')" 
                    icon="fa-solid fa-upload"
                    variant="primary"
                    class="ml-2 my-2"/>
                <GekkoButton 
                    @click="share()" 
                    :text="$gettext('Share')" 
                    icon="fa-solid fa-share"
                    variant="outline-primary"
                    class="ml-2 my-2"/>
            </template>
        </TitleBar>
        <div class="content">
             <div v-if="!$store.getters['getIsPremium']" class="gk-tip gk-tip--warning gk-tip--caution my-4" :style="tipCssVars">
                 <span>{{ $gettext('As a non-Premium user, you can only upload up to three documents. Please consider ') }}</span>
                 <a href="/en/subscriptions/manage/">{{ $gettext('upgrading!') }}</a>
             </div>
            <DocumentsTable />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import DocumentsTable from "@/components/documents/DocumentsTable";

export default {
    name: "Documents",
    components: {TitleBar, GekkoButton, DocumentsTable},
    methods: {
        upload() {
            this.$router.push({name: 'AddDocument'});
        },
        share() {
            this.$router.push({name: 'ShareDocuments'});
        }
    },
    computed: {
    tipCssVars() {
         return `--cautiontext: '${ this.$gettext('Gekko premium tip') }'`
    }
}
}

</script>

<style scoped lang="scss">
  .gk-tip--caution:after {
    content: var(--cautiontext);
  }
</style>